import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

export const ProgressItemLoading = () => {
  return <Skeleton width={80} height={24} variant="text" />;
};

export default ProgressItemLoading;
